import { useContext } from "react";
import ApplicationContext from "../ApplicationContext";
import { findSecurityTask } from "../util";
import { FmsSecTask } from "../fms.core/constants";
import useGlobalOkDialog from "./useGlobalOkDialog";
import { NavigationType, openNewPage } from "../util/navigationHelpers";
import { useHistory } from "react-router";

export function useSecureNavigate() {
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  return (secTask: FmsSecTask, navigate: string | (() => void)) => {
    const sec = findSecurityTask(appContext, secTask);
    if (sec.grantRead) {
      if (typeof navigate === 'string') { // url 전달
        openNewPage(history, navigate, NavigationType.newPage);
      } else {
        navigate(); // funtion이 전달될 때도 있음
      }
    } else {
      showGlobalOkDialog("Please check your user security!!!");
    }
  };
}